import { DatePipe } from '@angular/common';
import { LinkifyPipe } from '../../filters/linkify.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import {
	Component,
	OnInit,
	inject,
	ViewChild,
	ElementRef,
	HostListener,
	Output,
	EventEmitter,
	OnDestroy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import ChatService from '../../services/chat.service';
import ChatRestServices from '../../services/chat-rest.service';
import { Input } from '@angular/core';
import AngularFilterHelperService from "../../services/angular-filter-helper.service";
import DialogServices from "../../services/dialog.service";
import AngularHelperService from "../../services/angular-helper.service";
import AngularBroadcastHelperService from "../../services/angular-broadcast-helper.service";
import Config from "../../utils/config.service";
import {Subscription} from "rxjs";

@Component({
	standalone: true,
	selector: 'item-message',
	templateUrl: './item-message.component.html',
	imports: [ CommonModule, DatePipe, LinkifyPipe, TranslatePipe, FormsModule ]
})
export class ItemMessageComponent implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private chatService: ChatService = inject(ChatService);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
    private config: Config = inject(Config);

	@Input() lastSeen: any | undefined;
	@Input() isPreview: any | undefined;
	@Input() chat: any;
	@Input() message: any;
	@Input() group: any;
	@Input() isBold: any | undefined;
	@Input() isMessageOnly: any | undefined;
	
	vm: any = undefined;
	activeMessage: any | null = null;
	isDesktop = window.innerWidth >= 768;
	broadcastSubscriptions: Array<Subscription> = [];

	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.isServiceProvider = this.vm.user.businessUserType === 'SERVICE_PROVIDER';
		
		this.vm.getCallingMessage = this.chatService.getCallingMessage;
		this.vm.onMouseLeave = this.onMouseLeave;
		this.vm.onMouseEnter = this.onMouseEnter;
		this.vm.editMessage = this.editMessage;
		this.vm.deleteMessage = this.deleteMessage;
		
		var metadata: any = this.vm.message && this.vm.message.metadatas && this.vm.message.metadatas.find(function(item) {
			return item.type === 'TRANSLATE_TEXT';
		});
		
		if (metadata) {
			try {
				this.vm.metadata = JSON.parse(metadata.metadata);
				this.vm.metadata.type = metadata.type;
			} catch (e) {
				console.error(e);
			}
		}

		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onMessageMenuRequested',
				(event, parameters) => { this.handleMessageMenuRequest(event, parameters); })
		);
	}

	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}

	translate(message) {
		if (message.isTranslating) {
			return;
		}
		message.isTranslating = true;
		this.chatRestServices.translate({original: message.content},
			(res) => {
				this.message.content = res.translation;
				message.isTranslating = false;
			},
			(err) => {
				console.log(err);
				message.isTranslating = false;
			});
	}
	
	getSvgDataUrl(color: string): string {
		const svg = `
		    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
		      <circle cx="12" cy="12" r="10"/>
		      <path d="M2 12h20M12 2c2.5 2.5 4 5.5 4 10s-1.5 7.5-4 10M12 2C9.5 4.5 8 7.5 8 12s1.5 7.5 4 10"/>
		    </svg>
		`;
		return `data:image/svg+xml;base64,${btoa(svg)}`;
	}
	onMessageClick(message: any) {
		if (!message.deleted && !this.isDesktop && (this.vm.user.id === message.user.id) && !!!message.aiSessionId) {
			message.showActions = !message.showActions;
			this.activeMessage = message.showActions ? { message, container: null } : null;
		}
	}

	onMouseEnter(message: any) {
		if (this.isDesktop && (this.vm.user.id === message.user.id) && !!!message.aiSessionId) {
			console.log(message);
			console.log(this.vm.user);
			message.showDots = true;
		}
	}

	onMouseLeave(message: any) {
		if (this.isDesktop) {
			message.showDots = false;
		}
	}

	onMouseLeaveMenu(message: any) {
		message.showActions = false;
	}

	toggleActions(message: any, event: Event, container: HTMLElement) {
		event.stopPropagation();
		message.showActions = !message.showActions;

		message.showDots = true;

		this.activeMessage = message.showActions ? { message, container } : null;

		if (message.showActions) {
			this.angularBroadcastHelperService.rootBroadcast('onMessageMenuRequested', message);
		}
	}

	handleMessageMenuRequest(event, message) {
		if (message && message.id !== this.message.id) {
			this.message.showActions = false
		}
	}

	@HostListener('window:resize')
	onResize() {
		this.isDesktop = window.innerWidth >= 768;
	}

	@HostListener('document:click', ['$event'])
	onClickOutside(event: Event) {
		if (!this.activeMessage) return;

		const target = event.target as HTMLElement;
		const { message, container } = this.activeMessage;

		if (message.showActions && container && !container.contains(target)) {
			message.showActions = false;
			if (this.isDesktop) message.showDots = false;
			this.activeMessage = null;
		}
	}


	editMessage(message: any) {
		this.vm.chat.editingMessage = message;
		this.vm.chat.message = message.content;
	}

	deleteMessage(message: any) {
		this.handleDeleteMessage(message);
	}

	handleDeleteMessage(textMessage: any) {
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Modal.Content.Delete_Message_Confirmation'),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.vm.loading = true;
				var chat: any = this.angularHelperService.copy(this.vm.chat);
				var message: any = {
					id: textMessage.id,
					contentType: 'TEXT',
					content: this.angularFilterHelperService.translate('Chats.Other.Deleted'),
					chat: {
						id: this.vm.chat.id
					}
				};
				this.chatRestServices.updateChatMessage(
					{ forUser: this.vm.chat.privateChatFriend.id, isDeleted: true }, message,
					(res) => {
						this.vm.loading = false;
						this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.CHAT_POST_DELETED, [res], chat.id);

					},
					(err) => {
						console.error(err);
						this.vm.loading = false;
					}
				);
			}
		});
	}


	// handleDocumentClick = (event: MouseEvent) => {
	// 	const target = event.target as HTMLElement;
	//
	// 	if (this.vm.message.showActions && !target.closest('.chat-message-container')) {
	// 		this.vm.message.showActions = false;
	// 	}
	// };



}